export const validationDocument = (report) => {
  const { reader, datario, files, original_name, subject_reader_id } =
    report || {};

  const emailSuperReader = process.env.REACT_APP_SUPER_READER_EMAIL;

  const errors = [];

  if (!reader) errors.push("reader");
  if (!datario) errors.push("datario");

  if (reader?.email === emailSuperReader) {
    if (!subject_reader_id) errors.push("subject_reader_id");
  }

  if ((!files || files.length === 0) && !original_name) {
    errors.push("files");
  }

  return errors;
};
